'use client';

import { useAuth0AccessTokenSync } from './useAuth0AccessTokenSync';
import { useAuth0LoyaltyClaimSync } from './useAuth0LoyaltyClaimSync';

/**
 * Keeps Auth0 tokens in sync with the rest of the app.
 *
 * Mounted as a child of `Auth0Provider` so `useAuth0()` is available. Access-token
 * cookie writes, 401 refresh, inactivity logout, callback navigation, and loyalty-
 * claim reminting each stay in their own hook. Both hooks run unconditionally so a
 * callback error from token sync cannot skip the loyalty remint (Rules of Hooks).
 */
export function Auth0TokenSync() {
  useAuth0AccessTokenSync();
  useAuth0LoyaltyClaimSync();
  return null;
}